import React, {useEffect, useState} from "react";
import {getHomeData} from "../../Api/home";
import Section from "../../Components/Section";
import Header from "../../Components/Header";
import Collaborators from "../../Components/Collaborators";
import Subscribe from "../../Components/Subscribe";
import Gallery from "../../Components/Gallery";
import Salones from "../../Components/Salones";

const Home = () => {

    const [data, setData] = useState(undefined);

    useEffect(() => {
        getHomeData().then((response) => {
            setData(response.data.data.fields);
        });
    }, [])

    if (data === undefined) return (<div>Loading...</div>);
    return (
        <div>
            <Header dataHeader={{...data.header}}/>
            <Section {...data.section1} />
            <Gallery  data={data.gallery}/>
            <Header dataHeader={{...data.headerSalones}}/>
            <Salones dataSalones={{...data.salones}}/>
            <Section {...data.section2} />
            <Collaborators colData={data.colaboradores}/>
            <Subscribe subData={data.suscription}/>
        </div>
    );
}

export default Home;
